import { useState, useRef, useEffect } from "react";
import { ChevronDown, Coins } from "lucide-react";
import { useCurrency, CURRENCY_META } from "@/lib/currency";

export default function CurrencySwitcher({ light = false }) {
  const { currency, setCurrency, enabled } = useCurrency();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const meta = CURRENCY_META[currency] || CURRENCY_META.EUR;

  useEffect(() => {
    const fn = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("click", fn);
    return () => document.removeEventListener("click", fn);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        data-testid="currency-switcher-btn"
        onClick={() => setOpen(!open)}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-sm text-sm transition-colors ${
          light ? "hover:bg-white/10" : "hover:bg-brand-secondary/50"
        }`}
        aria-label="Currency"
      >
        <Coins size={14} />
        <span className="uppercase tracking-wider text-xs">{meta.code}</span>
        <ChevronDown size={12} />
      </button>
      {open && (
        <div data-testid="currency-switcher-menu" className="absolute right-0 mt-2 w-48 bg-white border border-brand-border rounded-sm shadow-lg overflow-hidden z-50">
          {enabled.map((c) => {
            const m = CURRENCY_META[c] || { code: c, symbol: c, label: c, flag: "" };
            return (
              <button
                key={c}
                data-testid={`currency-option-${c}`}
                onClick={() => { setCurrency(c); setOpen(false); }}
                className={`w-full text-left px-4 py-2.5 text-sm flex items-center gap-3 hover:bg-brand-bg ${c === currency ? "text-brand-primary font-medium" : "text-brand-text"}`}
              >
                <span className="text-base w-5 text-center">{m.symbol}</span>
                <span>{m.label}</span>
                <span className="ml-auto text-xs text-brand-muted">{m.code}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
